import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PathService} from "./path.service";
import {Observable} from "rxjs";
import {IdInfo, ListWrapper, OkInfo} from "../util/interfaces";
import {map} from "rxjs/operators";

export type BackendRole = 'user'|'print'|'admin'|'super';

export interface BackendUser {
    id: number;
    email: string;
    type: BackendRole;
    disabled: Date;
    created: Date;
    updated: Date;
}

@Injectable({
    providedIn: 'root'
})
export class BackendUserService {

    private readonly root: string;

    constructor(private http: HttpClient,
                private pathService: PathService) {
        this.root = `${this.pathService.apiRoot}/backend-user`;
    }

    public getAll(): Observable<BackendUser[]> {
        return this.http.get<ListWrapper<BackendUser>>(this.root).pipe(
            map(out => out.list)
        );
    }

    public add(email: string, type: BackendRole): Observable<IdInfo> {
        return this.http.post<IdInfo>(this.root, {email: email, type: type})
    }

    public update(user: BackendUser): Observable<OkInfo> {
        return this.http.put<OkInfo>(`${this.root}/${user.id}`, {type: user.type});
    }

    public disable(user: BackendUser): Observable<OkInfo> {
        return this.http.delete<OkInfo>(`${this.root}/${user.id}`);
    }

    public enable(user: BackendUser): Observable<OkInfo> {
        return this.http.put<OkInfo>(`${this.root}/${user.id}/enabled`, {});
    }
}
